import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, OnInit, Output } from '@angular/core';

import { combineLatest, map, Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementTypes, Step } from '@fcom/common';
import { MediaQueryService } from '@fcom/common/services';
import { BookingSteps } from '@fcom/common/interfaces/booking/booking-step.interface';
import { BookingService } from '@fcom/booking/services';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { ButtonTheme, IconButtonSize, IconButtonTheme, IconPosition } from '@fcom/ui-components';

import { ShoppingCartService } from '../../services/shopping-cart.service';

export interface SubHeaderActionButton {
  label: string;
  ariaLabel?: string;
  icon: SvgLibraryIcon;
}

@Component({
  selector: 'fin-sub-header',
  styleUrls: ['sub-header.component.scss'],
  templateUrl: 'sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubHeaderComponent implements OnInit {
  private mediaQueryService = inject(MediaQueryService);
  private bookingService = inject(BookingService);
  private shoppingCartService = inject(ShoppingCartService);

  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;

  STEPS: BookingSteps = BOOKING_STEPS;

  hasBasket = input<boolean>();
  isBasketDisabled = input<boolean>();
  hasActiveBasketState = input<boolean>();
  hasBasketActionInMobileOnly = input<boolean>();
  backgroundColorClass = input<string>('nordic-blue-900-bg surface-contrast');
  showInfoIcon = input<boolean>();
  staticHeight = input<boolean>(true);
  noHeader = input<boolean>(false);
  actionButton = input<SubHeaderActionButton>();
  cartButtonPositionLeft = input<boolean>(false);

  @Output()
  openBasket: EventEmitter<Event> = new EventEmitter<Event>();
  @Output()
  changeStep: EventEmitter<Step> = new EventEmitter<Step>();
  @Output()
  actionButtonClick: EventEmitter<Event> = new EventEmitter<Event>();

  isMobile$: Observable<boolean>;
  step$: Observable<Step>;
  showModifyButton$: Observable<boolean>;
  shoppingCartEnabled: boolean;

  constructor() {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
    this.step$ = this.bookingService.step;
  }

  ngOnInit(): void {
    this.showModifyButton$ = combineLatest([this.isMobile$, this.step$]).pipe(
      map(([isMobile, step]) => !isMobile && step.phase === BOOKING_STEPS.FLIGHT_SELECTION.phase)
    );
    this.shoppingCartEnabled = this.shoppingCartService.isEnabled();
  }
}
